module.exports = __webpack_public_path__ + "media/images/career_camp/2022/dividers/footer_mountains_sm-737050cad2b8c2ccbeace6397b7897c7.svg";